import { forOwn, has, isEqual, isPlainObject, transform } from 'lodash';

import { isEmpty } from './';

export function deepDiffObj(base: Object, target: Object) {
  return {
    // 这个顺序非常重要，不能变。会影响到 diff 的 value，diff 的 value 必须是 target 里面的值
    ...deepDiffObjInner(target, base),
    ...deepDiffObjInner(base, target)
  };
}

export function deepDiffObjInner(base: Object, object: Object) {
  if (!object) {
    throw new Error(`The object compared should be an object: ${object}`);
  }
  if (!base) {
    return object;
  }
  const result = transform(object, (result: any, value, key) => {
    if (!has(base, key) && !isEmpty(value)) {
      result[key] = value;
    }
    if (!isEqualWithEmpty(value, base[key])) {
      result[key] =
        isPlainObject(value) && isPlainObject(base[key])
          ? deepDiffObj(base[key], value)
          : value;
    }
  });
  // map removed fields to undefined
  forOwn(base, (value, key) => {
    if (
      !has(object, key) &&
      !isEqualWithEmpty(value, base[key as keyof Object])
    ) {
      result[key] = undefined;
    }
  });
  return result;
}

export const isEqualWithEmpty = (a: any, b: any) => {
  if (a === b) {
    return true;
  }
  if (isEmpty(a)) {
    return isEmpty(b);
  }
  return isEqual(a, b);
};
